function toMatrix(arr, width) {
  return arr.reduce(
    (rows, key, index) => (index % width === 0 ? rows.push([key])
      : rows[rows.length - 1].push(key)) && rows, [],
  );
}


function initBoardEmpty(boardLength) {
  const board = Array(boardLength ** 2).fill(2);
  return toMatrix(board, boardLength);
}


function addSides(board) {
  for (const arr of board) {
    arr.unshift(3);
  }
  board.unshift(Array(board.length + 1).fill(3));
  board[0][0] = 4;
  return board;
}


export default function initalization(boardLength) {
  const board = initBoardEmpty(boardLength);
  return addSides(board);
}
